import { z } from 'zod';

export const productSortingSchema = z.enum(['expensive-first', 'cheap-first', 'new-first', 'old-first']).nullish();

export type ProductSortingSchema = z.infer<typeof productSortingSchema>;
